/* AURORA FOR MEN — Landing page JS (vanilla, sin dependencias externas).
   Este archivo se referencia desde cada sección aurora-*.liquid (para que
   siga funcionando aunque el merchant borre alguna sección puntual); el
   guard de abajo evita que se inicialice más de una vez por página. */
(function () {
  'use strict';
  if (window.__auroraLandingInit) return;
  window.__auroraLandingInit = true;

  // Fade-in on scroll for elements with .aurora-fade-in
  var fadeEls = document.querySelectorAll('.aurora-fade-in');
  if (fadeEls.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    fadeEls.forEach(function (el) { io.observe(el); });
  } else {
    fadeEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  // Sticky mobile add-to-cart bar: show once the hero has scrolled out of view.
  var stickyBar = document.querySelector('[data-aurora-sticky-cart]');
  var heroAnchor = document.querySelector('[data-aurora-hero-anchor]');
  if (stickyBar && heroAnchor && 'IntersectionObserver' in window) {
    var stickyIo = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    stickyIo.observe(heroAnchor);
  }

  // "Personas viendo este producto" — número simulado, se randomiza al
  // cargar y cada N segundos (definido por el merchant en la sección).
  document.querySelectorAll('[data-aurora-viewers]').forEach(function (el) {
    var countEl = el.querySelector('[data-aurora-viewers-count]');
    if (!countEl) return;
    var min = parseInt(el.getAttribute('data-min'), 10) || 8;
    var max = parseInt(el.getAttribute('data-max'), 10) || 35;
    if (max < min) { var tmp = min; min = max; max = tmp; }
    var interval = parseInt(el.getAttribute('data-interval'), 10) || 12000;

    function randomize() {
      var n = Math.floor(Math.random() * (max - min + 1)) + min;
      countEl.textContent = n;
    }

    randomize();
    setInterval(randomize, interval);
  });

  // Popup de actividad: rota entre el mensaje real (si hay un pedido
  // reciente) y los mensajes genéricos configurados. Nunca inventa datos:
  // si no hay mensajes disponibles, no se muestra nada.
  document.querySelectorAll('[data-aurora-activity-popup]').forEach(function (root) {
    if (sessionStorage.getItem('auroraActivityClosed')) return;

    var script = root.querySelector('[data-aurora-activity-messages]');
    var messages = [];
    try {
      messages = JSON.parse(script.textContent);
    } catch (e) {
      messages = [];
    }
    if (!messages.length) return;

    var card = root.querySelector('[data-aurora-activity-card]');
    var textEl = root.querySelector('[data-aurora-activity-text]');
    var closeBtn = root.querySelector('[data-aurora-activity-close]');
    var delayMs = parseInt(root.getAttribute('data-delay-ms'), 10) || 5000;
    var displayMs = parseInt(root.getAttribute('data-display-ms'), 10) || 6000;
    var intervalMs = parseInt(root.getAttribute('data-interval-ms'), 10) || 10000;
    var index = 0;
    var timer = null;

    function showNext() {
      textEl.textContent = messages[index % messages.length];
      index++;
      card.classList.add('is-visible');
      window.setTimeout(function () {
        card.classList.remove('is-visible');
      }, displayMs);
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        card.classList.remove('is-visible');
        sessionStorage.setItem('auroraActivityClosed', '1');
        if (timer) window.clearInterval(timer);
      });
    }

    window.setTimeout(function () {
      showNext();
      timer = window.setInterval(showNext, displayMs + intervalMs);
    }, delayMs);
  });

  // Galería del Hero: click en una miniatura cambia la foto principal.
  document.querySelectorAll('[data-aurora-hero-gallery]').forEach(function (gallery) {
    var mainImg = gallery.querySelector('[data-aurora-hero-gallery-main] img');
    var thumbs = gallery.querySelectorAll('[data-aurora-hero-thumb]');
    if (!mainImg || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-src');
        var srcset = thumb.getAttribute('data-srcset');
        if (!src) return;
        mainImg.src = src;
        if (srcset) mainImg.srcset = srcset;
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });
})();
